import React from "react";
import { Grid, Tab, Tabs } from "@mui/material";
import { Link, Route, Switch } from "react-router-dom";
import { PeopleDatatableWithActions } from "./PeopleDatatableWithActions";
import { PeopleSalariesDatatableWithActions } from "./PeopleSalaries/PeopleSalariesDatatableWithActions";
import { useRouteMatch } from "../../Helpers/RouteMatcher";
import { userRolesState } from "../../State/user.Atom";
import { useRecoilValue } from "recoil";
import { BEE123SalariesEditRole, BEE123SalariesViewRole, EE123SalariesRole_Edit, EE123SalariesRole_View } from "../../Component/Common/Constants/UserRoles";

export const PeopleBase = () => {

    const routes = [
        "/people/Database",
        "/people/Salaries",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;

    const userRoleAccess = [
        EE123SalariesRole_Edit,
        EE123SalariesRole_View,
        BEE123SalariesEditRole,
        BEE123SalariesViewRole
    ];

    const userRoles = useRecoilValue(userRolesState);

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="People" value={routes[0]} to={routes[0]} component={Link} />
                        {userRoles.some(r => userRoleAccess.includes(r)) && <Tab label="Salaries" value={routes[1]} to={routes[1]} component={Link} />}
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <Switch>
                        <Route path={routes[0]}>
                            <PeopleDatatableWithActions />
                        </Route>
                        <Route path={routes[1]}>
                            <PeopleSalariesDatatableWithActions />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}